// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"3861aed0","783":"24c0f1f8","915":"350dadd1","958":"cb9edc7b"}[chunkId] + ".chunk.js";
};